import { ContactI18n } from '@/locales/base.message.locales';

export const contact: ContactI18n = {
  text: 'Em breve retornaremos seu contato por email.',
  title: 'Sua mensagem foi</br>enviada com sucesso',
  us: {
    text: 'Conectar-se à Liga Social Global é rápido. <br/> Basta preencher os campos abaixo e enviaremos as informações que você desejar.',
    title: 'Fale conosco',
  },
  email: {
    failed: 'Desculpe, ocorreu um erro ao enviar o e-mail de contato, tente novamente!',
    success: 'Obrigado! E-mail de contato enviado com sucesso, aguarde a resposta.'
  }
};
